import { CLUB_GENDER_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/club';
import { WEEK_DAYS_SHORT_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/date';
import { ClubProgrammeBadgeKind } from 'Src/types/clubProgramme';
import { ColumnDefinition } from 'Src/helpers/table/table';
import { FILTER_TYPE } from 'Src/consts/table';
import { getAge, getGender } from 'Src/helpers/accessor/accessor';

export const WEEK_DAYS_ORDER: string[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export const badgeClass = (kind: ClubProgrammeBadgeKind) => {
  if (kind === 'danger') return 'cpBadge cpBadge--danger';
  if (kind === 'warn') return 'cpBadge cpBadge--warn';
  if (kind === 'info') return 'cpBadge cpBadge--info';
  return 'cpBadge cpBadge--ok';
};

export const getProgrammeClubDayShortLabel = (dayRaw: any) => {
  const d = String(dayRaw || '');
  return (WEEK_DAYS_SHORT_SERVER_TO_CLIENT_MAPPING as any)[d] || d;
};

export const getProgrammeClubGenderLabel = (club: any) => {
  const g = String((club && club.gender) || '');
  return (CLUB_GENDER_SERVER_TO_CLIENT_MAPPING as any)[g] || g;
};

export const INVITE_FILTERS_EMPTY = {
  firstName: '',
  lastName: '',
  forms: [] as string[],
  ages: [] as string[],
  gender: [] as string[]
};

export const INVITE_ITEMS_COLUMNS: ColumnDefinition[] = [
  { text: 'Surname', field: 'lastName', accessor: ['lastName'], type: FILTER_TYPE.TEXT, isSort: false },
  { text: 'Name', field: 'firstName', accessor: ['firstName'], type: FILTER_TYPE.TEXT, isSort: false },
  { text: 'Form', field: 'forms', accessor: ['form', 'name'], type: FILTER_TYPE.MULTISELECT, isSort: false },
  { text: 'Age', field: 'ages', accessor: getAge, type: FILTER_TYPE.MULTISELECT, isSort: false },
  { text: 'Gender', field: 'gender', accessor: getGender, type: FILTER_TYPE.MULTISELECT, isSort: false }
];
